import { render, staticRenderFns } from "./AdditionalInfo.vue?vue&type=template&id=d7d63892"
import script from "./AdditionalInfo.vue?vue&type=script&lang=js"
export * from "./AdditionalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7d63892')) {
      api.createRecord('d7d63892', component.options)
    } else {
      api.reload('d7d63892', component.options)
    }
    module.hot.accept("./AdditionalInfo.vue?vue&type=template&id=d7d63892", function () {
      api.rerender('d7d63892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/preview/AdditionalInfo.vue"
export default component.exports